import {createUseStyles} from 'react-jss';
import Spacing from '../../../style-helper/Spacing';

export default createUseStyles({
  collectionOverlayButton: {
    color: props => !props.isUsingArtemisStyles && '#333',
    marginTop: [Spacing.double],
    fontSize: '95%',
    fontWeight: props => props.theme.core.boldFontWeight,
  },
});
